export default __webpack_public_path__ + "static/media/nike.b80d00eb.jpg";